import { ProtectedJsonAPI } from '.'

export const ReportDescriptions = ProtectedJsonAPI.extend(
  '/oadr/report_descriptions',
  {
    show:    endpoint => endpoint.path(({id}) => id)
  }
)